import { useEffect, useState } from 'react';
import MagicLinkForm from './MagicLinkForm';
import ChatScreen from './ChatScreen';
import { loadSession, saveSession, clearSession, cfg } from './session';

export default function SupportApp({ embedded = false }) {
    const [session, setSession] = useState(null);
    const [phase, setPhase] = useState('init');

    useEffect(() => {
        const url = new URL(window.location.href);
        const magicToken = url.searchParams.get('token');

        if (magicToken) {
            setPhase('exchanging');
            fetch(`${cfg.apiUrl}/support/validate-token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: magicToken }),
            })
                .then(async (res) => {
                    const body = await res.json();
                    if (!res.ok) throw new Error(body.message);
                    return body;
                })
                .then((data) => {
                    saveSession(data);
                    setSession(data);
                    setPhase('chat');
                    url.searchParams.delete('token');
                    window.history.replaceState({}, '', url.toString());
                })
                .catch(() => setPhase('expired'));
            return;
        }
        const stored = loadSession();
        if (stored) {
            setSession(stored);
            setPhase('chat');
        } else {
            setPhase('login');
        }
    }, []);

    function handleLoggedIn(data) {
        saveSession(data);
        setSession(data);
        setPhase('chat');
    }
    function handleLogout() {
        clearSession();
        setSession(null);
        setPhase('login');
    }

    if (phase === 'init' || phase === 'exchanging') {
        return <div style={{ padding: 32, textAlign: 'center', color: '#666' }}>Bezig...</div>;
    }
    if (phase === 'expired') {
        return (
            <div style={{ padding: 24, textAlign: 'center' }}>
                <h3 style={{ color: '#c8102e', margin: 0 }}>Link verlopen</h3>
                <p style={{ color: '#666' }}>Vraag een nieuwe magic-link aan.</p>
                <button onClick={() => setPhase('login')}
                        style={{ background: '#c8102e', color: '#fff', border: 0, padding: '10px 20px', borderRadius: 6, cursor: 'pointer' }}>
                    Nieuwe link aanvragen
                </button>
            </div>
        );
    }
    if (phase === 'chat' && session) {
        return <ChatScreen session={session} onLogout={handleLogout} embedded={embedded} />;
    }
    return <MagicLinkForm onLoggedIn={handleLoggedIn} embedded={embedded} />;
}
